import { __extends } from 'tslib';
import * as React from 'react';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

var transitionAppearTimeout = 0;
var component = 'div';
var transitionEnter = false;
var transitionLeave = false;
var StepCSSTransitionGroup = (function (_super) {
    __extends(StepCSSTransitionGroup, _super);
    function StepCSSTransitionGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepCSSTransitionGroup.prototype.render = function () {
        var content = null;
        if (this.props.children !== undefined && this.props.children !== null) {
            content = (React.createElement(ReactCSSTransitionGroup, { id: this.props.id, className: this.props.className, component: component, transitionName: {
                    appear: 'step',
                    appearActive: "step-active-" + this.props.level,
                }, transitionEnter: transitionEnter, transitionLeave: transitionLeave, transitionAppear: true, transitionAppearTimeout: transitionAppearTimeout }, this.props.children));
        }
        return content;
    };
    return StepCSSTransitionGroup;
}(React.PureComponent));

export { StepCSSTransitionGroup as default };
//# sourceMappingURL=StepCSSTransitionGroup.js.map
